import React from 'react';

import {SEOWithQuery} from 'src/components/shared';
import {CATEGORY, EDITORIAL, PODCAST} from 'src/routes/paths';

import {Maybe, SanityCategory, SanityEditorial} from 'types/generated';

import {GridCard} from '../../components/editorial/GridCard';
import {Pagination} from '../../components/shared/Pagination';
import {SupportingContent} from '../editorial/SupportingContent';
import {InsightsNavigation} from '../insightsNavigation';

interface CategoryProps {
  category: SanityCategory;
  categoryArticles: [Maybe<SanityEditorial>];
  limit: number;
  currentPage: number;
  numPages: number;
  location: Location;
}

const CategoryTemplate: React.FC<CategoryProps> = ({
  category,
  categoryArticles,
  currentPage,
  numPages,
}: CategoryProps) => {
  const Posts = categoryArticles.map((item, key) => {
    return (
      <GridCard
        key={key}
        title={item?.title}
        category={item?.editorialCategory?.title}
        image={item?.heroImage}
        slug={item?.slug?.current}
        url={item?.isPodcast ? `${PODCAST}/${item?.slug?.current}` : `${EDITORIAL}/${item?.slug?.current}`}
        cardColClasses={'grid-list_item '}
        imageClasses={'grid-list_image '}
        contentClasses={'grid-list_content'}
        titleClasses={'type-epsilon mt-3'}
        eyebrowClasses={'grid-list_eyebrow '}
        editorialCategory={item?.editorialCategory}
        isPodcast={item?.isPodcast}
      />
    );
  });
  return (
    <>
      {currentPage >= 2 ? (
        <SEOWithQuery noIndex={true} />
      ) : (
        <SEOWithQuery
          title={category.seo?.seoMetaTitle || category.title || undefined}
          description={category?.seo?.seoDescription || undefined}
          image={category?.seo?.seoImage?.asset?.url || undefined}
        />
      )}

      <div className="bg-white">
        <InsightsNavigation bgColor={'bg-white'} />
        <div className="bg-white">
          <section className="px-gutter text-black page-module-spacing" data-module="category-hero">
            <div className="wrapper-default">
              <h2 className="type-beta text-center">{category.title}</h2>
              {category.description && (
                <p className="type-sm-p mt-3 md:mt-5 mx-auto text-center text-gray-4">{category.description}</p>
              )}
            </div>
          </section>
          <section className={`px-gutter module-spacing pt-0`} data-module="article-grid-list">
            <div className="wrapper-default grid grid-cols-4 md:grid-cols-12 grid-spacing">
              {Posts}
              {numPages > 1 && (
                <div className="col-span-full">
                  <div className="flex items-center justify-center w-full flex-col md:flex-row">
                    <div>
                      <Pagination
                        currentPage={currentPage}
                        numPages={numPages}
                        slug={`${CATEGORY.replace('/', '')}/${category.slug?.current}`}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default CategoryTemplate;
